import { AlertLineURLDTO } from "src/models/alert-line-url/alert-line-url-dto";
import { STOModel } from "src/models/base/sto-model";
import { BaseApiService } from "../base";

export class PublicAlertLineURLApiService extends BaseApiService<AlertLineURLDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/AlertLine",
      loadItemsPath: "/GetPublicAlertLineURLs",
      // loadItemsPath : "/GetAlertLineURLs"
    });
  }
}
